export enum PCFBiogenicEmissionsMode {
  Include = 'Include',
  Exclude = 'Exclude',
}
